import React from "react";

function SideCard({ title, children, icon }) {
  return (
    <div className="p-5 bg-grayish rounded-2xl shadow-md border border-gray-100 animate-fadeSlideUp ">
      <div className="flex items-center gap-2 mb-4 border-b pb-2">
        {icon && <span className="text-main1 text-lg">{icon}</span>}
        <h6 className="text-base font-semibold text-main1">{title}</h6>
      </div>
      <div className="space-y-2 text-sm text-gray-700">{children}</div>
    </div>
  );
}

export default SideCard;
